module.exports = __webpack_public_path__ + "img/officialAccounts.1b67a094.png";